import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs, withDefaults } from 'vue';
  import { getSimpleType } from '@/helpers';
  import ProgressBar from '@/components/ProgressBar.vue';
  import BaseText from '@ui/atoms/baseText/BaseText.vue';
  import { FileUploadStatus } from '@/components/common/fileUploadModal/types';
  import Loader from '@/components/common/Loader.vue';
  import { humanFileSize } from '@/helpers/filters';
  import { Colors } from '@/constant/theme';

  
  const __default__ = {
    name: 'FileUploadRow',
  };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    fileType: { type: String, required: true },
    fileName: { type: String, required: true },
    fileSize: { type: Number, required: true },
    status: { type: null, required: false, default: null },
    uploadPercent: { type: Number, required: true }
  },
  emits: ["remove"],
  setup(__props: any, { emit }: { emit: ({ (event: 'remove', fileName: string): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { fileType: string, fileName: string, fileSize: number, status: FileUploadStatus | null, uploadPercent: number };

  
  const { fileType, fileName, fileSize, status, uploadPercent } = toRefs(props);

  

  const progressBarColor = computed(() => {
    if (status.value === FileUploadStatus.Completed) {
      return Colors.GREEN_LIGHT;
    }

    return Colors.PRIMARY_RED;
  });

  const statusText = computed(() => {
    if (status.value === FileUploadStatus.Uploading) {
      return 'Uploading...';
    } else if (status.value === FileUploadStatus.PendingProcess) {
      return 'Waiting for the file to be processed...';
    } else if (status.value === FileUploadStatus.Processing) {
      return 'Processing file...';
    } else if (status.value === FileUploadStatus.Completed) {
      return 'Upload successful';
    } else if (status.value === FileUploadStatus.Failed) {
      return 'Upload failed';
    }

    return null;
  });

  const statusTextStyle = computed(() => {
    if (status.value === FileUploadStatus.Completed) {
      return {
        color: Colors.GREEN_LIGHT,
      };
    } else if (status.value === FileUploadStatus.Failed) {
      return {
        color: Colors.PRIMARY_RED,
      };
    }

    return null;
  });

  function handleRemove() {
    emit('remove', fileName.value);
  }

return { __sfc: true,props, fileType, fileName, fileSize, status, uploadPercent, emit, progressBarColor, statusText, statusTextStyle, handleRemove, getSimpleType, ProgressBar, BaseText, FileUploadStatus, Loader, humanFileSize }
}

})